import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import mapboxgl from 'mapbox-gl';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { constants } from './constants';
import { Router } from './Router';
import { queryClient } from './services/datastore/react-query';
import { Toast } from './services/toast/Toast';
import { ToastRef } from './services/toast/utils';

import './services/error-reporting/init';
import './index.css';

// print package version in console, usefull for cache debugging
console.log(constants.appVersion);

mapboxgl.accessToken = constants.mapBoxApiKey;

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <>
          <Helmet>
            <title>Allocab</title>
          </Helmet>
          <Router />
          <Toast ref={ToastRef} />
          <ReactQueryDevtools initialIsOpen={false} />
        </>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
